module.exports = __webpack_public_path__ + "static/media/logo.79d46b12.png";